module.exports = __webpack_public_path__ + "static/media/3.25208951.jpg";